<div class="sign-in" libRandomBackground>
  <div class="logo">
    <img src="assets/images/GrantOne_Logo_light.svg" alt="GrantOne"/>
  </div>
  <div class="sign-in-box">
    <div class="sign-in-header">
      <h1>Log ind</h1>
      <h2>GrantOne Administration</h2>
    </div>
    <div class="sign-in-body">
      <button
        (click)="goToMitId()"
        class="float-left pill mitid-login-button"
        mat-flat-button
      >Login med MitID</button>
      <div class="mt-3">
        @if (hasError) {
          <h4 style="color: red">Brugeren findes ikke admin systemet</h4>
        }
      </div>
    </div>

  </div>
</div>
